import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import Programmes from './pages/Programmes';
import ProgrammeLeadership from './pages/ProgrammeLeadership';
import ProgrammeEveryday from './pages/ProgrammeEveryday';
import ForOrganisations from './pages/ForOrganisations';
import About from './pages/About';
import Contact from './pages/Contact';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="programmes" element={<Programmes />} />
          <Route path="programmes/ai-leadership-boards" element={<ProgrammeLeadership />} />
          <Route path="programmes/gen-ai-everyday" element={<ProgrammeEveryday />} />
          <Route path="for-organisations" element={<ForOrganisations />} />
          <Route path="about" element={<About />} />
          <Route path="contact" element={<Contact />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;